import React from "react";
import { useParams } from "react-router-dom";
import SeoLandingPage from "@/pages/public/SeoLandingPage";
import NotFound from "@/pages/public/NotFound";
import { MEDICAL_PAGES } from "@/data/site";

export default function DispositivoMedicoSub() {
  const { slug } = useParams();
  const data = MEDICAL_PAGES[slug];
  if (!data) return <NotFound />;
  return (
    <SeoLandingPage
      data={{ ...data, cta: "regulatory" }}
      category="Dispositivo medico"
      showDisclaimer
      crumbs={[{ label: "Dispositivo Medico", path: "/dispositivo-medico" }, { label: data.title }]}
    />
  );
}
